<template>
  <div>
    <CustomError v-if="is_error" close="errorClose" />
    <Loading v-if="is_loading" />
    <v-row class="pa-2">
      <v-btn color="success" dark class="mb-2" @click="loadFieldsFromTemplateSet"
        >Load fields from template
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="error" dark class="mb-2" @click="resetFields">Reset </v-btn>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="fields"
      sort-by="orderNumberInForm"
      class="elevation-1"
      v-if="!is_loading"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item.data.hasDependencies="{ item }">
        <v-checkbox v-model="item.data.hasDependencies" disabled></v-checkbox>
      </template>
      <template v-slot:item.data.required="{ item }">
        <v-checkbox v-model="item.data.required" disabled></v-checkbox>
      </template>
      <template v-slot:item.data.active="{ item }">
        <v-checkbox v-model="item.data.active" @change="changed(item)"></v-checkbox>
      </template>
      <template v-slot:item.data.indexNumber="{ item }">
        <input
          type="number"
          min="1"
          :max="fields.length"
          v-model="item.data.indexNumber"
          @change="changed(item)"
        />
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Form fields</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="flex-grow-1"></div>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Add New Field</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Edit field</span>
              </v-card-title>
              <v-card-text>
                <Field :field="editedItem" :editMode="editMode" v-if="dialog" />
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" v-if="item.data.editAble">edit</v-icon>
        <v-icon small @click="deleteItem(item)" v-if="item.data.editAble">delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Field from '@/components/Field'
import Loading from '@/components/Loading'
import CustomError from '@/components/CustomError'

import { mapGetters, mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import IMAGE_MODES from '@/constants/imageModes'
export default {
  name: 'Fields',
  components: {
    Field,
    Loading,
    CustomError
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Sorting', value: 'data.indexNumber', sortable: false },
        {
          text: 'Title',
          align: 'left',
          value: 'data.title'
        },
        { text: 'Type', value: 'data.type', sortable: false },
        { text: 'Required', value: 'data.required', sortable: false },
        {
          text: 'Dependencies',
          value: 'data.hasDependencies',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        },
        { text: 'Active', value: 'data.active', sortable: false }
      ],
      editedIndex: -1,
      editedItem: null,
      defaultItem: {
        _id: null,
        data: {
          title: '',
          type: 'text',
          attrs: {
            // hasMin:false,
            // hasMax:false,
            // hasOpt:false,
            // min:1,
            // max:100,
            options: []
          },
          imageMode: 0,
          multiple: false,
          required: true,
          active: true,
          editAble: true
        }
      },
      editMode: false
      //   fields:[]
    }
  },
  methods: {
    ...mapGetters('fields', ['allFields', 'isLoading', 'isError']),
    ...mapActions('fields', [
      'load',
      'add',
      'update',
      'delete',
      'resetFieldsDB',
      'loadFieldsFromTemplate',
      'setError'
    ]),
    ...mapGetters('images', ['allImages']),
    errorClose() {
      this.setError(null)
    },
    async loadFieldsFromTemplateSet() {
      if (confirm('Are you shure? It may take several minutes.')) {
        await this.loadFieldsFromTemplate()
        await this.load()
      }
    },
    resetFields() {
      if (confirm('Are you shure?')) this.resetFieldsDB()
    },
    changed(item) {
      this.update({ field: item })
    },
    editItem(item) {
      this.editMode = true
      this.editedIndex = this.fields.indexOf(item)
      this.editedItem = cloneDeep(item)
      this.dialog = true
    },
    deleteItem(item) {
      try {
        if (confirm('Are you sure you want to delete this item?')) {
          this.delete(item)
        }
      } catch {}
    },
    close() {
      this.editMode = false
      this.dialog = false
      this.editedItem = cloneDeep(this.defaultItem)
      this.editedIndex = -1
    },
    save() {
      if (!isNaN(this.editedItem.data.imageMode))
        this.editedItem.data.imageMode = Object.keys(IMAGE_MODES).map(key => IMAGE_MODES[key])[
          this.editedItem.data.imageMode
        ]
      try {
        if (this.editedItem.data.hasDependencies) {
          const obj = {}
          Object.keys(this.editedItem.data.dependencies)
            .filter(key => this.editedItem.data.dependencies[key].length > 0)
            .forEach(key => (obj[key] = [...this.editedItem.data.dependencies[key]]))
          this.editedItem.data.dependencies = obj
        } else delete this.editedItem.data.dependencies

        if (this.editMode) {
          this.update({ field: this.editedItem, images: this.allImages() })
        } else {
          this.editedItem.data.editAble = true
          this.add({ data: this.editedItem.data, images: this.allImages() })
        }
      } catch {}
      this.close()
    }
  },
  computed: {
    fields() {
      return this.allFields()
    },
    is_loading() {
      return this.isLoading()
    },
    is_error() {
      return this.isError()
    }
  },
  mounted() {
    this.load()
    this.editedItem = cloneDeep(this.defaultItem)
  }
}
</script>

<style lang="scss" scoped></style>
